import React, { useCallback, useState } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import PhoneNotice from './PhoneNotice';
import FullscreenControl from './FullscreenControl';
import { SideHandoff, SideViewPicker, SideWindowControls, sideViewAvailable } from './SideViewControls';
import { appShell, installAppShell } from './appShell';
import { isPhoneBrowser } from './phoneGate';
import { sideViewFrom } from './sideView';

// A phone never opens a TV session or downloads the 3D scene: it gets the
// big-screen notice instead (Cole, 2026-09-25).
const onPhone = isPhoneBrowser(navigator.userAgent, window.location.search);
// Inside the Samsung app (web/tv/tizen): Back exits, no Full screen button.
installAppShell();
// Side view (sideView.ts): this page is the side window.
const sideWindow = sideViewFrom(window.location.search);
if (sideWindow) document.documentElement.classList.add('side-window');
const offerSideView = !appShell && !sideWindow && sideViewAvailable();

function Root() {
  const [handoff, setHandoff] = useState<Window | null>(null);
  const [blocked, setBlocked] = useState(false);
  const back = useCallback(() => setHandoff(null), []);
  if (handoff) return <SideHandoff win={handoff} onBack={back} />;
  return (
    <>
      <App />
      {appShell ? null : sideWindow ? (
        <SideWindowControls side={sideWindow} />
      ) : (
        <FullscreenControl>
          {offerSideView ? (
            <SideViewPicker
              onOpened={(win) => {
                setBlocked(false);
                setHandoff(win);
              }}
              onBlocked={() => setBlocked(true)}
            />
          ) : null}
        </FullscreenControl>
      )}
      {blocked ? (
        <button type="button" className="side-view-blocked" onClick={() => setBlocked(false)}>
          The browser blocked the side window. Allow pop-ups for this site, then try Side view again.
        </button>
      ) : null}
    </>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {onPhone ? <PhoneNotice /> : <Root />}
  </React.StrictMode>,
);
